require('./date-input.jade')
moment = require('moment')

DateInputDirective = ->
  restrict: 'A'
  templateUrl: 'components/form/date-input.jade'
  require: 'ngModel'
  replace: true
  scope:
    date: '=dateInputDate'
    tindex: '=tIndex'
  link: (scope, elem, attr, ctrl) ->
    #add name to div to easy to find in submit button
    elem.attr("name", ctrl.$name)
    $year = elem.find('[name=year]')
    isValidYear = ->
      $year.val().length is 4

    refreshDate = ->
      if (not scope.year and not scope.month and not scope.day)
        ctrl.$setValidity 'dateValidate', true
        ctrl.$setValidity 'dateRequired', false
        return

      ctrl.$setValidity 'dateRequired', true
      if scope.year and scope.month and scope.day
        m = moment [scope.year, scope.month - 1, scope.day]
        scope.date = if m.isValid() then m else undefined
        ctrl.$setValidity 'dateValidate', m.isValid() and isValidYear()
      else
        scope.date = undefined
        ctrl.$setValidity 'dateValidate', false

    scope.$watch 'year + month + day', -> refreshDate()
    scope.$watch 'date', ->
      if scope.date
        #The Api sometime return a string Date ex: "1914-04-04".
        #We don't want to convert back to moment object in every controller so we need to check to convert.
        scope.date = (if typeof scope.date is "string" then moment(scope.date) else scope.date)
        scope.year = scope.date.year()
        #Months are zero indexed, so January is month 0.
        scope.month = scope.date.month() + 1
        scope.day = scope.date.date()

module.exports = DateInputDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/form/date-input-directive.coffee